import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/components/app';
import Error from '@/components/app/error';

Vue.use(VueRouter);

const routes = [
	{ path: '/', name: 'dashboard', component: Dashboard, meta: { breadcrumb: [{ text: 'Dashboard' }] } },
	{ path: '/error', name: 'error', component: Error, meta: { breadcrumb: [{ text: 'Error' }] } },
    { path: '/:pathMatch(.*)*', name: 'dashboard', component: Dashboard, meta: { breadcrumb: [{ text: 'Dashboard' }] } }
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
